module.exports = __webpack_public_path__ + "img/14.327b86a5.png";